export const auth = {
  namespaced: true,
  
  state: {
    token: localStorage.getItem('cliente_token') || null,
    ficha: JSON.parse(localStorage.getItem('cliente_ficha') || 'null'),
    expiresAt: localStorage.getItem('cliente_expires_at') || null
  },
  
  mutations: {
    SET_TOKEN(state, { token, expires_in }) {
      state.token = token
      const expiresAt = Date.now() + (expires_in * 1000)
      state.expiresAt = expiresAt
      
      localStorage.setItem('cliente_token', token)
      localStorage.setItem('cliente_expires_at', expiresAt)
    },
    
    SET_FICHA(state, ficha) {
      state.ficha = ficha
      localStorage.setItem('cliente_ficha', JSON.stringify(ficha))
    },
    
    CLEAR_AUTH(state) {
      state.token = null
      state.ficha = null
      state.expiresAt = null
      
      localStorage.removeItem('cliente_token')
      localStorage.removeItem('cliente_ficha')
      localStorage.removeItem('cliente_expires_at')
    }
  },
  
  actions: {
    setAuth({ commit }, { token, expires_in, ficha }) {
      commit('SET_TOKEN', { token, expires_in })
      commit('SET_FICHA', ficha)
    },
    
    clearAuth({ commit }) {
      commit('CLEAR_AUTH')
    }
  },
  
  getters: {
    isAuthenticated: state => {
      if (!state.token || !state.expiresAt) return false
      return Date.now() < state.expiresAt
    },
    
    token: state => state.token,
    ficha: state => state.ficha
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/auth.js